import axios from 'axios';

const getList = async function journalServiceGetList (params) {
  const response = await axios.get('/api/journal/', { params });

  return response.data.data;
};

export default {
  getList,
};
